var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.5H20V17.5H0V15.5H2V8.5C2 7.04667 2.36667 5.7 3.1 4.46C3.80667 3.26 4.76 2.30667 5.96 1.6C7.2 0.866667 8.54667 0.5 10 0.5C11.4533 0.5 12.8 0.866667 14.04 1.6C15.24 2.30667 16.1933 3.26 16.9 4.46C17.6333 5.7 18 7.04667 18 8.5V15.5ZM16 15.5V8.5C16 7.42 15.7267 6.41333 15.18 5.48C14.6467 4.57333 13.9267 3.85333 13.02 3.32C12.0867 2.77333 11.08 2.5 10 2.5C8.92 2.5 7.91333 2.77333 6.98 3.32C6.07333 3.85333 5.35333 4.57333 4.82 5.48C4.27333 6.41333 4 7.42 4 8.5V15.5H16ZM7 19.5H13V21.5H7V19.5Z",
    fill: "#707793"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e6cd191917988b061f21d34644e3fcfc.svg";
export { ForwardRef as ReactComponent };